import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Row, Col, Space, PaginationProps, message } from "antd";
import { columns, columnsLeDao, columnsNA } from "./config";
import { nurseOutService } from "api";
import { ListActionButton, Notification } from "components/common";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "./ModalContent/ModalContent";
import moment from "moment";
import { tabKeys } from "types/enums";
import { useSelector } from "react-redux";
import { useAppSelector } from "redux/hooks";
import ModalContentLD from "./ModalContent/ModalContentLD";
import ModalContentNA from "./ModalContent/ModalContentNA";

const CatalogEyeMedicine = () => {
  const modalRef = useRef<any>();
  const modalRefLD = useRef<any>();
  const modalRefNA = useRef<any>();
  const ldRef = useRef<any>();
  const naRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [listDilate, setListDilate] = useState<any>([]);
  const [listLeDao, setListLeDaoe] = useState<any>([]);
  const [listNA, setListNA] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const dataSource = [
    { STT: 1, id: 1, name: 1, description: 1, modifieBy: "" },
  ];
  const activetab = useAppSelector((e) => e.common.activeTab);
  useEffect(() => {
    if (activetab === tabKeys.NURSE_OUT.CATALOG) {
      getListDilate();
      getListLeDao();
      getListNA();
    }
  }, [activetab]);
  columns.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteDilate(_record.id);
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRef.current?.openModal();
        }}
      ></ListActionButton>
    );
  };

  //COlumns lệ đạo
  columnsLeDao.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteLeDao(_record.id);
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRefLD.current?.openModal();
        }}
      ></ListActionButton>
    );
  };

  //columns nhãn áp
  columnsNA.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteNA(_record.id);
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRefNA.current?.openModal();
        }}
      ></ListActionButton>
    );
  };

  //Tra thuốc
  const getListDilate = async () => {
    setLoading(true);
    try {
      const res = await nurseOutService.getListDilate();
      setListDilate(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách thuốc tra mắt");
    }
  };
  const deleteDilate = async (id) => {
    try {
      const res = await nurseOutService.deleteDilate(id);
      Notification("success", "Đã xóa dữ liệu tra thuốc");

      await getListDilate();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu tra thuốc");
    }
  };

  //lệ đạo
  const getListLeDao = async () => {
    setLoading(true);
    try {
      const res = await nurseOutService.getListLeDao();
      setListLeDaoe(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách lệ đạo");
    }
  };
  const deleteLeDao = async (id) => {
    try {
      const res = await nurseOutService.deleteLD(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");

      await getListLeDao();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu lệ đạo");
    }
  };

  //Nhãn áp
  const getListNA = async () => {
    setLoading(true);
    try {
      const res = await nurseOutService.getListNA();
      setListNA(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách lệ đạo");
    }
  };
  const deleteNA = async (id) => {
    try {
      const res = await nurseOutService.deleteNA(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");

      await getListNA();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu lệ đạo");
    }
  };
  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    // getListDilate();
  };

  return (
    <div>
      <Space
        direction="vertical"
        className="Dilate container"
        style={{ width: "100%" }}
      >
        <Row justify={"space-between"}>
          <Col>
            <div className="title">Danh mục thuốc tra mắt</div>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                setType("Thêm");
                setRecord(null);
                modalRef.current?.openModal();
              }}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
        <div className="container-table">
          <Table
            loading={loading}
            bordered
            columns={columns}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              onChange: onChange,
            }}
            dataSource={listDilate}
          />

          <ModalCustom
            ref={modalRef}
            width={1000}
            title={`${type} thuốc tra mắt`}
          >
            <ModalContent
              data={record}
              getListDilate={getListDilate}
              type={type}
            ></ModalContent>
          </ModalCustom>
        </div>
      </Space>

      {/* Lệ đạo */}
      {/* <Space
        direction="vertical"
        className="Dilate container"
        style={{ width: "100%" }}
      >
        <Row justify={"space-between"}>
          <Col>
            <div className="title">Danh mục lệ đạo</div>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                setType("Thêm");
                setRecord(null);
                modalRefLD.current?.openModal();
                ldRef.current.resetFields();
              }}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
        <div className="container-table">
          <Row gutter={16}>
            <Col span={12}>
              <Table
                loading={loading}
                bordered
                columns={columnsLeDao}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  // onChange: onChange,
                }}
                dataSource={listLeDao.filter((el) => el.type === 0)}
              />
            </Col>
            <Col span={12}>
              <Table
                loading={loading}
                bordered
                columns={columnsLeDao}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                }}
                dataSource={listLeDao.filter((el) => el.type === 1)}
              />
            </Col>
          </Row>
        </div>
      </Space> */}
      {/* Nhãn áp */}
      <Space
        direction="vertical"
        className="Dilate container"
        style={{ width: "100%" }}
      >
        <Row justify={"space-between"}>
          <Col>
            <div className="title">Danh mục nhãn áp</div>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                setType("Thêm");
                setRecord(null);
                modalRefNA.current?.openModal();
                naRef.current.resetFields();
              }}
            >
              Thêm mới
            </Button>
          </Col>
        </Row>
        <div className="container-table">
          <Table
            loading={loading}
            bordered
            columns={columnsNA}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
            }}
            dataSource={listNA}
          />
        </div>
      </Space>
      <ModalCustom ref={modalRef} width={1000} title={`${type} thuốc tra mắt`}>
        <ModalContent
          data={record}
          getListDilate={getListDilate}
          type={type}
        ></ModalContent>
      </ModalCustom>

      {/* Lệ đạo */}
      <ModalCustom ref={modalRefLD} width={1200} title={`${type} lệ đạo`}>
        <ModalContentLD
          ref={ldRef}
          data={record}
          getListLeDao={getListLeDao}
          type={type}
        />
      </ModalCustom>

      {/* Nhãn áp */}
      <ModalCustom ref={modalRefNA} width={1400} title={`${type} nhãn áp`}>
        <ModalContentNA
          ref={naRef}
          data={record}
          getListNA={getListNA}
          type={type}
        />
      </ModalCustom>
    </div>
  );
};
export default CatalogEyeMedicine;
